import React, { useState, useEffect } from 'react';

import Icon from '../Icon';
import { Label } from '../Label';
import { Tooltip } from '../Tooltip';

interface DateSelectorType {
  initialDate?: string;
  value?: string;
  updateDate: (date: string) => void;
  label: string;
  hideLabel?: boolean;
  id?: string;
  tooltipMessage?: string;
  warningMessage?: string;
}

const DateSelector = ({
  initialDate,
  value,
  updateDate,
  label,
  hideLabel,
  id,
  tooltipMessage,
  warningMessage,
}: DateSelectorType) => {
  const [selectedDate, setSelectedDate] = useState(value ?? initialDate ?? '');

  // Update internal state when controlled value changes
  useEffect(() => {
    if (value !== undefined) {
      setSelectedDate(value);
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    const newValue = `${e.target.value}`;
    setSelectedDate(newValue);
    updateDate(newValue);
  };

  return (
    <div>
      {hideLabel ? null : (
        <div className="flex items-center justify-start gap-1">
          {tooltipMessage && (
            <Tooltip message={tooltipMessage} tooltipPosition="top">
              <Icon name="infoCircleLetterI" />
            </Tooltip>
          )}
          <Label label={label} id={id ?? ''} />
        </div>
      )}
      <div className="sp-input-field-div-wrapper flex items-center">
        <input
          className={`sp-input sp-input-field sp-select-field ${
            warningMessage ? 'sp-input-warning !border-sp-warning-300' : ''
          }`}
          aria-label={label}
          value={selectedDate}
          type="date"
          onChange={handleChange}
        />
      </div>
      {warningMessage && (
        <div className="text-sp-warning-500 mt-1 max-w-[150px] break-words text-xs">
          {warningMessage}
        </div>
      )}
    </div>
  );
};

DateSelector.defaultProps = {
  hideLabel: false,
  label: null,
  initialDate: '',
};

export default DateSelector;
